@if (visible()) {
  <div class="mini-feed">
    <mat-icon class="live-icon">circle</mat-icon>
    <div class="mini-feed-items">
      @for (event of recentEvents(); track trackByEventId($index, event)) {
        <a class="mini-item" target="_blank" [href]="event.amazonlink">
          @if (event.imagename) {
            <img class="mini-img" [src]="event.imagename | amazonImage:48" alt="" loading="lazy" />
          }
          <span class="mini-title">{{ event.title }}</span>
          <span class="mini-price">
            {{ event.displayusedprice | currency: currencyMap[domain()]:'symbol':'1.0-2' }}
          </span>
        </a>
      }
    </div>
    <a routerLink="/livefeed" [queryParams]="{ domain: domain() }" class="view-all">
      Live
      <mat-icon class="view-all-icon">arrow_forward</mat-icon>
    </a>
  </div>
}
